import { render, staticRenderFns } from "./review-create.vue?vue&type=template&id=82ee3bbe&scoped=true"
import script from "./review-create.vue?vue&type=script&lang=js"
export * from "./review-create.vue?vue&type=script&lang=js"
import style0 from "./review-create.vue?vue&type=style&index=0&id=82ee3bbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ee3bbe",
  null
  
)

export default component.exports